export const CHART_TYPE = {
  PERSONAL: "PERSONAL",
  ENTERPRISE: "ENTERPRISE",
};
